// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar.css
// module id = 1110
// module chunks = 0